<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="区域：">
          <el-cascader
            placeholder="--选择区域--"
            size="large"
            :options="options"
            v-model="queryForm.region"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="门店名称：">
          <el-input v-model.trim="queryForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="门店ID：">
          <el-input type="number" v-model="queryForm.id" clearable></el-input>
        </el-form-item>
        <el-form-item label="经销商：" prop="partnerId">
          <el-select
            clearable
            filterable
            remote
            :remote-method="getPartnerData"
            v-model="queryForm.partnerId"
            placeholder="--选择经销商--"
          >
            <el-option
              v-for="item in partnerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button type="primary" @click="getTableData">导出表格</el-button>
          <!-- <el-button type="primary" @click="download">打印</el-button> -->
        </el-form-item>
      </el-form>
      <!-- 批量上传 -->

      <el-row type="flex" class="row-bg" justify="first">
        <el-form style="width: 200px" class="demo-form-inline forms">
          <el-form-item label="批量上传：">
            <el-upload
              ref="upload"
              class="upload-demo"
              action
              :on-change="handleChange"
              :on-remove="handleRemove"
              :limit="limitUpload"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              :auto-upload="false"
            >
              <div class="el-upload__text" style="color: #fff">选择文件</div>
              <div slot="tip" class="el-upload__tip">
                只 能 上 传 xlsx / xls 文 件
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-form
          style="
            width: 240px;
            heigth: 36px;
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
          "
        >
          <el-button
            size="medium"
            type="primary"
            @click="up"
            :loading="isLoading"
            >上传</el-button
          >
          <div class="muban">
            <a
              style="color: #fff"
              download="门店管理模板.xlsx"
              :href="
                'https://ppf-wx.oss-cn-shanghai.aliyuncs.com/%E9%97%A8%E5%BA%97%E7%AE%A1%E7%90%86%E6%A8%A1%E6%9D%BF.xlsx?' +
                  new Date().getTime()
              "
              >模板下载</a
            >
          </div>
        </el-form>
      </el-row>
    </div>
    <el-progress
      v-if="disabled"
      :text-inside="true"
      :stroke-width="26"
      :percentage="100"
    ></el-progress>

    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" key="id" label="编号"></el-table-column>
          <el-table-column
            prop="name"
            key="name"
            label="门店名称"
          ></el-table-column>
          <el-table-column
            prop="contact"
            key="contact"
            label="联系人"
          ></el-table-column>
          <el-table-column
            prop="phoneNumber"
            key="phoneNumber"
            label="电话"
          ></el-table-column>
          <el-table-column
            prop="username"
            key="username"
            label="账号"
          ></el-table-column>
          <el-table-column
            prop="partnerName"
            key="partnerName"
            label="经销商"
          ></el-table-column>
          <el-table-column
            prop="regionName"
            label="地区"
            key="regionName"
          ></el-table-column>
          <el-table-column
            prop="fullAddress"
            label="详细地址"
            key="fullAddress"
          ></el-table-column>
          <el-table-column prop="status" label="状态" key="status">
            <template slot-scope="scope">
              {{
                scope.row.status == 1
                  ? "未审核"
                  : scope.row.status == 2
                  ? "已审核"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column width="150" key="todo" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="modify(scope.$index, scope.row)"
                size="small"
                :disabled="scope.row.status !== 1"
                >审核</el-button
              >
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
              <span @click="cz(scope.$index, scope.row)" class="btns"
                >重置密码</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改门店"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item class="ts">
          <el-form-item label="门店名称：" prop="name">
            <el-input v-model.trim="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="门店账号：" prop="username">
            <el-input v-model.trim="editForm.username"></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item class="ts">
          <el-form-item
            label="经销商："
            prop="partnerId"
            style="float: left; width: 50%"
          >
            <el-select
              clearable
              filterable
              remote
              :remote-method="getPartnerData"
              v-model="editForm.partnerId"
              placeholder="--选择经销商--"
            >
              <el-option
                v-for="item in partnerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="门店区域："
            prop="region"
            style="float: left; width: 50%"
          >
            <el-cascader
              placeholder="--选择区域--"
              size="large"
              :options="options"
              v-model="editForm.region"
            ></el-cascader>
          </el-form-item>
        </el-form-item>
        <el-form-item label="详细地址：" prop="fullAddress">
          <el-input
            v-model.trim="editForm.fullAddress"
            @blur="getALocation"
          ></el-input>
          <p>
            <span>经度：{{ editForm.lon }}</span>
            <span style="margin-left: 20px">纬度：{{ editForm.lat }}</span>
          </p>
          <div id="container" v-show="keywords"></div>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="联系电话：" prop="phoneNumber">
            <el-input
              type="number"
              :maxlength="11"
              oninput="if(value.length>11)value=value.slice(0,11)"
              v-model.trim="editForm.phoneNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="contact">
            <el-input v-model.trim="editForm.contact"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="门店图片：">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加门店"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="门店名称：" prop="name">
          <el-input v-model.trim="newForm.name"></el-input>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="门店账号：" prop="username">
            <el-input v-model.trim="newForm.username"></el-input>
          </el-form-item>
          <el-form-item label="门店密码：" prop="password">
            <el-input v-model.trim="newForm.password"></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item class="ts">
          <el-form-item
            label="经销商："
            prop="partnerId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="newForm.partnerId"
              placeholder="--选择经销商--"
              clearable
              filterable
              remote
              :remote-method="getPartnerData"
            >
              <el-option
                v-for="item in partnerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="门店区域："
            prop="region"
            style="float: left; width: 50%"
          >
            <el-cascader
              placeholder="--选择区域--"
              size="large"
              :options="options"
              v-model="newForm.region"
            ></el-cascader>
          </el-form-item>
        </el-form-item>
        <el-form-item label="详细地址：" prop="fullAddress">
          <el-input
            v-model.trim="newForm.fullAddress"
            @blur="getALocation"
          ></el-input>
          <p>
            <span>经度：{{ newForm.lon }}</span>
            <span style="margin-left: 20px">纬度：{{ newForm.lat }}</span>
          </p>
          <div id="container" v-show="keywords"></div>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="联系电话：" prop="phoneNumber">
            <el-input
              type="number"
              :maxlength="11"
              oninput="if(value.length>11)value=value.slice(0,11)"
              v-model.trim="newForm.phoneNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="contact">
            <el-input v-model.trim="newForm.contact"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="门店图片：">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="editPasswordVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handlePassClose"
    >
      <el-form
        :model="editPasswordForm"
        label-width="120px"
        ref="editPasswordForm"
        :rules="rules"
        status-icon
        class="demo-ruleForm"
      >
        <el-form-item label="密码" prop="pass">
          <el-input
            type="password"
            v-model="editPasswordForm.pass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="editPasswordForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="UpassCancel('editPasswordForm')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click.native="UpdatePassWord('editPasswordForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import areaData from "../utils/china-area.json";
import moment from "dayjs";
import { getYYS, getMD } from "./../axios/api";
import { writeFile } from "../utils/xlsx";

export default {
  name: "Md",
  data() {
    return {
      editPasswordVisible: false, //密码弹框
      editFormVisible: false, //弹框
      editPasswordForm: {
        pass: "",
        checkPass: ""
      },
      keywords: "",
      options: areaData, // 城市信息
      partnerList: [], // 经销商
      imagesWF: [],
      limitUpload: 1, // 限制上传数量
      isLoading: false, // 上传
      newData: false, //弹框
      queryForm: {
        name: "",
        partnerId: null,
        region: ""
      },
      editForm: {
        name: "",
        contact: "",
        phoneNumber: "",
        username: "",
        password: "",
        partnerId: null,
        region: "",
        fullAddress: "",
        lat: "",
        lon: ""
      }, //弹框数据
      newForm: {
        name: "",
        contact: "",
        phoneNumber: "",
        username: "",
        password: "",
        partnerId: null,
        region: "",
        fullAddress: "",
        lat: "",
        lon: ""
      },
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      percentage: 0,
      disabled: false,
      eTableData: [],
      eTabelLoading: false,
      rules: {
        name: [{ required: true, message: "请输入门店名称", trigger: "blur" }],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "请输入门店电话", trigger: "blur" }
        ],
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        partnerId: [
          { required: true, message: "请输入经销商", trigger: "change" }
        ],
        region: [
          { required: true, message: "请输入经销商地区", trigger: "change" }
        ],
        fullAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        lat: [{ required: true, message: "请输入纬度", trigger: "blur" }],
        lon: [{ required: true, message: "请输入经度", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        checkPass: [{ required: true, message: "请确认密码", trigger: "blur" }]
      }
    };
  },
  watch:{
    eTableData(newVal){
      console.log(newVal.length,this.total)
      if (newVal.length === this.total) {
        this.exprotData()
      }
    }
  },
  methods: {
    exprotData() {
      // 获取导出数据
      if (this.eTableData.length === this.total) {
        this.eTabelLoading = false;
        this.$message({
          type: "success",
          message: "导出成功！"
        });
        //
        const SheetHeader = [
          { key: "id", label: "编号" },
          { key: "name", label: "门店名称" },
          { key: "contact", label: "联系人" },
          { key: "phoneNumber", label: "联系电话" },
          { key: "username", label: "账号" },
          { key: "partnerName", label: "经销商" },
          { key: "regionName", label: "地区" },
          { key: "fullAddress", label: "详细地址" },
          {
            key: "status",
            label: "状态",
            render: value => ["", "未审核", "已审核"][value]
          },
          { key: "createdAt", label: "创建时间" }
        ];
        writeFile(
          this.eTableData,
          SheetHeader,
          `门店数据${moment(new Date()).format("YYYY-MM-DD")}`
        );
      }
    },
    //
    getTableData() {
      var that = this;
      that.eTabelLoading = true;
      this.$message({
        type: "warning",
        message: "正在导出请稍后！"
      });
      //获取经销商列表

      let data = {
        id: that.queryForm.id ? Number(that.queryForm.id) : undefined,
        name: that.queryForm.name ? that.queryForm.name : undefined,
        partnerId: that.queryForm.partnerId
          ? that.queryForm.partnerId
          : undefined,
        region: that.queryForm.region
          ? that.queryForm.region.join("")
          : undefined,
        pageNumber: 1,
        pageSize: 1000
      };
      // console.log(data)
      getMD.getTable(data).then(function(res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          let { list } = res.data;

          list.map(lis => {
            let addr = "";
            let province = lis.region.slice(0, 2);
            let town = lis.region.slice(2, 6);
            let district = lis.region.slice(6, 12);

            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );

            that.options.map(item1 => {
              if (item1.value === province) {
                addr += item1.label;
              }
            });

            that.options.map(item1 => {
              if (item1.value === province) {
                addr += item1.label;
                item1.children.map(item2 => {
                  if (item2.value === town) {
                    addr += item2.label;
                    item2.children.map(item3 => {
                      if (item3.value === district) {
                        addr += item3.label;
                      }
                    });
                  }
                });
              }
            });

            lis.regionName = addr;
          });

          that.eTableData = list;
        }
      });
    },
    // 获取经销商
    getPartnerData(query) {
      var that = this;

      //获取经销商列表
      let data = {
        pageNumber: 1,
        pageSize: 1000,
        name: query || undefined
      };
      // console.log(data)
      getYYS.getTable(data).then(function(res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          let { list } = res.data;

          that.partnerList = list;
        }
      });
    },
    // 加载地图
    getALocation() {
      let that = this;
      let addr = "";
      let province = this.newForm.region[0]
        ? this.newForm.region[0]
        : this.editForm.region[0];
      let town = this.newForm.region[1]
        ? this.newForm.region[1]
        : this.editForm.region[1];
      let district = this.newForm.region[2]
        ? this.newForm.region[2]
        : this.editForm.region[2];
      this.options.map(item1 => {
        if (item1.value === province) {
          addr += item1.label;
          item1.children.map(item2 => {
            if (item2.value === town) {
              addr += item2.label;
              item2.children.map(item3 => {
                if (item3.value === district) {
                  addr += item3.label;
                }
              });
            }
          });
        }
      });
      // 加载地图
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 15
      });
      let fullAddress = this.newForm.fullAddress
        ? this.newForm.fullAddress
        : this.editForm.fullAddress;
      let keywords = fullAddress ? addr + fullAddress : "";
      this.keywords = keywords;
      console.log(keywords);
      let data = {
        key: "692e0a1fa9af08757923129a8121c389",
        address: keywords
      };

      $.ajax({
        url: "https://restapi.amap.com/v3/geocode/geo",
        type: "get",
        dataType: "jsonp",
        data,
        success: function(data) {
          // console.log(data.geocodes[0].location)//获取到的经纬度
          console.log(data);
          if (data.status == 1) {
            let location = data.geocodes[0].location.split(",");
            let title = data.geocodes[0].formatted_address;
            console.log(location);
            that.newForm.lat = location[1];
            that.newForm.lon = location[0];
            that.editForm.lat = location[1];
            that.editForm.lon = location[0];

            var marker = new AMap.Marker({
              position: location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: title,
              offset: new AMap.Pixel(-10, -10)
            });
            // 将创建的点标记添加到已有的地图实例：
            map.add(marker);
            map.setFitView();
          } else {
            that.$message({
              type: "warning",
              message: "没有查询到对应的地址!"
            });
          }
        }
      });
    },
    // 上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file.raw);
      }
      // console.log(formData.get('file'))

      getMD
        .upload(formData)
        .then(function(res) {
          console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定"
            });
          } else {
            // console.log(res.data)

            that.imagesWF.push(res.data);

            that.$message.success("上传成功!");
          }
        })
        .catch(function(res) {});
    },
    // 上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },
    // 修改密码的关闭弹框
    handlePassClose() {
      this.editPasswordVisible = false;
      this.$refs["editPasswordForm"].resetFields();
      this.editPasswordForm = {};
    },
    // 修改密码取消
    UpassCancel(formName) {
      this.editPasswordVisible = false;
      this.editPasswordForm = {};
    },
    // 审核门店
    modify(index, row) {
      if (row.status == 1) {
        this.handleSwitch(row.id);
      }
    },
    handleSwitch(id) {
      let that = this;
      // return;
      let data = {
        status: 2
      };
      getMD
        .editTable(data, id)
        .then(function(res) {
          if (res.code !== 0) {
            that.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            that.$message({
              type: "success",
              message: "审核成功!"
            });
            that.editPasswordVisible = false;
            that.init();
          }
        })
        .catch(function(res) {
          that.editPasswordVisible = false;
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        });
    },
    // 修改密码 并且判断密码是否一致
    UpdatePassWord(forName) {
      var that = this;
      this.$refs["editPasswordForm"].validate(valid => {
        if (valid) {
          if (that.editPasswordForm.checkPass !== that.editPasswordForm.pass) {
            that.$message.error("两次输入密码不一致!");
          } else {
            let data = {
              password: that.editPasswordForm.checkPass
            };
            getMD
              .editTable(data, that.editPasswordForm.id)
              .then(function(res) {
                if (res.code !== 0) {
                  that.$alert(res.message, "提示", {
                    confirmButtonText: "确定"
                  });
                } else {
                  that.$message({
                    type: "success",
                    message: "密码更新成功!"
                  });
                  that.editPasswordVisible = false;
                  that.$refs["editPasswordForm"].resetFields();
                  that.init();
                }
              })
              .catch(function(res) {
                that.editPasswordVisible = false;
                that.$refs["editPasswordForm"].resetFields();
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //点击编辑
    bj: function(index, row) {
      console.log(row);
      var that = this;
      that.editFormVisible = true; //显示弹框

      that.editForm = row;

      // 区域
      let province = row.region.slice(0, 2);
      let town = row.region.slice(2, 6);
      let district = row.region.slice(6, 12);
      that.editForm.region = [province, town, district];

      let newData = [];
      row.images.map(img => {
        let imgs = {};
        imgs.url = img;
        newData.push(imgs);
      });

      that.imagesWF = newData;

      that.getPartnerData();
    },

    // 批量上传
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
      // console.log(this.fileTemp);
    },
    handleRemove(file, fileList) {
      this.fileTemp = null;
    },
    up: function() {
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type == "application/vnd.ms-excel"
        ) {
          this.isLoading = true;
          this.$message({
            type: "warning",
            message: "正在上传"
          });
          this.importfxx(this.fileTemp);
          this.fileTemp = null;
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！"
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！"
        });
      }
    },

    importfxx(obj) {
      let that = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function(e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary"
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
          // console.log(outdata);

          outdata.map(function(item) {
            item.name = item.门店名称 ? item.门店名称.toString() : "";
            item.contact = item.联系人 ? item.联系人.toString() : "";
            item.phoneNumber = item.电话 ? item.电话.toString() : "";
            item.username = item.账号 ? item.账号.toString() : "";
            item.password = item.密码 ? item.密码.toString() : "";
            item.partnerId = item.经销商 ? Number(item.经销商) : "";
            item.fullAddress = item.详细地址 ? item.详细地址.toString() : "";
            // item.lon = item.经度 ? item.经度.toString() : "";
            // item.lat = item.纬度 ? item.纬度.toString() : "";

            item.region = item.区域 ? item.区域.toString() : "";
            let region = item.region.split("/");
            let newRegion = "";

            that.options.map(item1 => {
              if (item1.label === region[0]) {
                newRegion += item1.value;
                item1.children.map(item2 => {
                  if (item2.label === region[1]) {
                    newRegion += item2.value;
                    item2.children.map(item3 => {
                      if (item3.label === region[2]) {
                        newRegion += item3.value;
                      }
                    });
                  }
                });
              }
            });

            item.region = newRegion.toString();

            let addr = item.区域 ? item.区域.toString() : undefined;

            if (addr) {
              // 处理经纬度
              let keywords = item.fullAddress ? addr + item.fullAddress : "";
              console.log(keywords);
              let data = {
                key: "692e0a1fa9af08757923129a8121c389",
                address: keywords
              };

              $.ajax({
                url: "https://restapi.amap.com/v3/geocode/geo",
                type: "get",
                dataType: "jsonp",
                data,
                success: function(data) {
                  // console.log(data.geocodes[0].location)//获取到的经纬度
                  console.log(data);
                  if (data.status == 1) {
                    let location = data.geocodes[0].location.split(",");

                    console.log(location);
                    item.lat = location[1];
                    item.lon = location[0];

                    if (item.lon && item.lat) {
                      that.batchNewUpdate(item);
                    }
                  } else {
                    that.$message({
                      type: "warning",
                      message: "没有查询到对应的地址!"
                    });
                  }
                }
              });
            }

            delete item.门店名称;
            delete item.联系人;
            delete item.电话;
            delete item.账号;
            delete item.密码;
            delete item.经销商;
            delete item.区域;
            delete item.详细地址;
            delete item.经度;
            delete item.纬度;
            delete item.备注;
          });
          // console.log(outdata);
          // // return;
          // // 调用上传接口
          // outdata.forEach((d) => {
          //   that.batchNewUpdate(d);
          // });
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },

    batchNewUpdate: function(batchData) {
      var that = this;
      getMD
        .addTable(JSON.stringify(batchData))
        .then(function(res) {
          console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定"
            });
          } else {
            that.$message.success("上传成功！");
            that.isLoading = false;
            that.init();
          }
        })
        .catch(function(res) {});
    },

    search: function() {
      this.currentPage = 1;
      this.init();
    },
    reset: function() {
      this.queryForm = {};
      this.currentPage = 1;
      this.init();
    },

    add: function() {
      this.newData = true; //显示弹框

      this.getPartnerData(); // 获取经销商
    },
    //点击关闭dialog
    newClose(done) {
      this.keywords = "";
      this.newForm.lat = "";
      this.newForm.lon = "";
      this.imagesWF = [];
      this.newData = false;
      this.$refs["newForm"].resetFields();
      this.newForm = {};

      this.getPartnerData(); // 获取经销商
    },
    //点击取消
    newCancel(formName) {
      this.keywords = "";
      this.newForm.lat = "";
      this.newForm.lon = "";
      this.imagesWF = [];
      this.newData = false;
      this.$refs["newForm"].resetFields();
      this.newForm = {};

      this.getPartnerData(); // 获取经销商
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      this.$refs["newForm"].validate(valid => {
        if (valid) {
          // if (that.imgList.length == 0) {
          //   this.$message.warning("请上传门店照片!");
          //   return;
          // }
          let newImages = [];
          that.imagesWF.map(img => {
            newImages.push(img.url);
          });
          var data = {
            name: that.newForm.name,
            contact: that.newForm.contact,
            phoneNumber: that.newForm.phoneNumber,
            username: that.newForm.username,
            password: that.newForm.password,
            partnerId: that.newForm.partnerId,
            region: that.newForm.region.join(""),
            fullAddress: that.newForm.fullAddress,
            lat: that.newForm.lat.toString(),
            lon: that.newForm.lon.toString(),
            images: newImages
          };
          console.log(data);
          // return
          getMD
            .addTable(JSON.stringify(data))
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                that.$message.success("添加成功!");
                that.disabled = false;
                that.newData = false;
                that.newForm = {};
                that.$refs["newForm"].resetFields();
                that.imagesWF = [];
                that.init();
              }
            })
            .catch(function(res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.init();
    },

    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.$refs["editForm"].clearValidate();
      this.imagesWF = [];
      this.newForm.lat = "";
      this.newForm.lon = "";

      this.getPartnerData(); // 获取经销商
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      this.$refs["editForm"].clearValidate();
      this.imagesWF = [];
      this.newForm.lat = "";
      this.newForm.lon = "";

      this.getPartnerData(); // 获取经销商
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      that.$refs["editForm"].validate(valid => {
        if (valid) {
          let newImages = [];
          that.imagesWF.map(img => {
            newImages.push(img.url);
          });
          var data = {
            name: that.editForm.name,
            contact: that.editForm.contact,
            phoneNumber: that.editForm.phoneNumber,
            username: that.editForm.username,
            partnerId: that.editForm.partnerId,
            region: that.editForm.region.join(""),
            fullAddress: that.editForm.fullAddress,
            lat: that.editForm.lat.toString(),
            lon: that.editForm.lon.toString(),
            images: newImages
          };
          getMD
            .editTable(data, that.editForm.id)
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                that.$message.success("更新成功!");
                that.editFormVisible = false;
                that.$refs["editForm"].clearValidate();
                that.imagesWF = [];
                that.init();
              }
            })
            .catch(function(res) {
              that.editFormVisible = false;
              that.$refs["editForm"].clearValidate();
              // console.log(res)
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //更新的时候就把弹出来的表单中的数据写到要修改的表格中

      // console.log(data)
    },
    //点击删除
    sc: function(index, row) {
      console.log(row);
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          getMD
            .delTable({
              id: row.id
            })
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            })
            .catch(function(res) {
              that.$message({
                type: "info",
                message: res.message
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //重置密码
    cz: function(index, row) {
      this.editPasswordVisible = true;
      // 密码
      this.editPasswordForm.id = row.id;
    },

    init: function() {
      var that = this;
      that.loading = true;

      //获取门店列表

      var data = {
        id: that.queryForm.id ? Number(that.queryForm.id) : undefined,
        name: that.queryForm.name ? that.queryForm.name : undefined,
        partnerId: that.queryForm.partnerId
          ? that.queryForm.partnerId
          : undefined,
        region: that.queryForm.region
          ? that.queryForm.region.join("")
          : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage
      };
      getMD.getTable(data).then(function(res) {
        // console.log(res);
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map(lis => {
            let addr = "";
            let province = lis.region.slice(0, 2);
            let town = lis.region.slice(2, 6);
            let district = lis.region.slice(6, 12);

            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );

            that.options.map(item1 => {
              if (item1.value === province) {
                addr += item1.label;
                item1.children.map(item2 => {
                  if (item2.value === town) {
                    addr += item2.label;
                    item2.children.map(item3 => {
                      if (item3.value === district) {
                        addr += item3.label;
                      }
                    });
                  }
                });
              }
            });

            lis.regionName = addr;
          });

          that.total = totalNumber;
          that.tableData = list;
        }
      });

      that.getPartnerData(); // 获取经销商
    }
  },
  mounted() {
    var that = this;

    that.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
#container {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/page/Md.vue